/* --- MON CODE --- */

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 990) {
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const track = document.querySelector('.product__media-list');
    if (!mediaWrapper || !track || mediaWrapper.querySelector('.byredo-prev')) return;

    const prevBtn = document.createElement('button');
    prevBtn.className = 'byredo-arrow byredo-prev';
    prevBtn.innerHTML = '❮';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'byredo-arrow byredo-next';
    nextBtn.innerHTML = '❯';

    mediaWrapper.style.position = 'relative';
    mediaWrapper.appendChild(prevBtn);
    mediaWrapper.appendChild(nextBtn);

    // Défilement basé sur la largeur exacte d'une slide pour éviter les décalages
    const getScrollAmount = () => {
      const slide = track.querySelector('.product__media-item');
      return slide ? slide.clientWidth : window.innerWidth * 0.55;
    };

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }
});